function CoursesController(){
	this.className	= "CoursesController";
	this.glob		= "/courses**";
	this.debug		= false;
};
CoursesController.inheritsFrom( StandardController );
CoursesController.prototype.setupPage = function(){
	console.log("CoursesController: setupPage called");
};
CoursesController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
CoursesController.prototype.on = function(){
	var state = nav.getState();

	this.setupPage();

	this.$startTrainingLink = $('.js-start-training-link');
	this.$startTrainingCourses = $('.js-start-training-courses');
	this.$startTrainingCourse = $('.js-start-training-course');

	this.popup = false;
	this.$startTrainingLink.on('click', Igloo.$d(this, function($this){
		console.log('startTrainingLink click');
		this.popup = new StartTrainingPopup({
			courseTitle: $this.attr("data-course-title"),
			courseID: $this.attr("data-course"),
			courseLink: $this.attr("data-course-link"),
			controller: this
		});
	}));

	if (state.nextHash) {
		const $hash = $(`#${state.nextHash}`);
		if ($hash.length) {
			$hash.addClass('open');
		}
	}
};
CoursesController.prototype.off = function(){
	if(this.popup) this.popup.destroy();
};